/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DailyMetrics } from '../models/daily-metrics';
import { getHarvestTarget } from '../fn/base/get-harvest-target';
import { GetHarvestTarget$Params } from '../fn/base/get-harvest-target';
import { getLiveSensorDataByHouse } from '../fn/base/get-live-sensor-data-by-house';
import { GetLiveSensorDataByHouse$Params } from '../fn/base/get-live-sensor-data-by-house';
import { LiveSensorDataDto } from '../models/live-sensor-data-dto';

@Injectable({ providedIn: 'root' })
export class BaseService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLiveSensorDataByHouse()` */
  static readonly GetLiveSensorDataByHousePath = '/api/liveSensorData/facilityGroupId/{facilityGroupId}';

  /**
   * Get Live Sensor Data By House.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLiveSensorDataByHouse()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLiveSensorDataByHouse$Response(params: GetLiveSensorDataByHouse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LiveSensorDataDto>>> {
    return getLiveSensorDataByHouse(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Live Sensor Data By House.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLiveSensorDataByHouse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLiveSensorDataByHouse(params: GetLiveSensorDataByHouse$Params, context?: HttpContext): Observable<Array<LiveSensorDataDto>> {
    return this.getLiveSensorDataByHouse$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LiveSensorDataDto>>): Array<LiveSensorDataDto> => r.body)
    );
  }

  /** Path part for operation `getHarvestTarget()` */
  static readonly GetHarvestTargetPath = '/api/liveTargetDataByHouse/facilityGroupId/{facilityGroupId}';

  /**
   * Get Harvest Target.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHarvestTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestTarget$Response(params: GetHarvestTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DailyMetrics>>> {
    return getHarvestTarget(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Harvest Target.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHarvestTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHarvestTarget(params: GetHarvestTarget$Params, context?: HttpContext): Observable<Array<DailyMetrics>> {
    return this.getHarvestTarget$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DailyMetrics>>): Array<DailyMetrics> => r.body)
    );
  }

}
